// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#tblMain[data-v-5829c400]{\n  width: 800px;\n}\n#tblSecond[data-v-5829c400]{\n  width: 1000px;\n}\n.btn[data-v-5829c400]{\n  color: white !important;\n  margin: 5px;\n  /*width: 40px;*/\n}\n.active[data-v-5829c400]{\n  background-color: #1abc9c;\n}\n", ""]);
// Exports
module.exports = exports;
